/* # =================================================================
# クライアントのブラウザがwebpをサポートしているか確認
# サポートしている場合は、bodyのデータ属性に追加
# ================================================================= */
export default function webpSupportCheck() {
	function testWebP(callback) {
		var webP = new Image();
		webP.onload = webP.onerror = function () {
			callback(webP.height === 2);
		};
		webP.src =
			'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
	}

	testWebP(function (support) {
		if (support) {
			document.body.dataset.webpSupport = 'true';
		} else {
			document.body.dataset.webpSupport = 'false';
		}
	});
}
